import React from 'react';
import styled, { css } from 'styled-components';
import CheckIcon from '../Icons/Check.icon';

export interface CheckboxProps {
  selected?: boolean;
  description: React.ReactNode;
  handleChange: Function;
}

const StyledCheckboxCaption = styled.div``;
const StyledCheckboxSelected = css`
  position: relative;
  border-color: ${({ theme }) => theme.colors.BLUE.B400};
  background: ${({ theme }) => theme.colors.BLUE.B400};
  color: ${({ theme }) => theme.colors.CARD};
`;
const StyledCheckbox = styled.div<{
  selected: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ theme }) => theme.colors.BORDER};
  border-radius: 6px;
  width: 16px;
  height: 16px;
  background: ${({ theme }) => theme.colors.CARD};
  transition: background 0.3s, border-color 0.3s;

  ${props => props.selected && StyledCheckboxSelected};
`;
const StyledCheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 2px 0;
  border-radius: 4px;
  user-select: none;
  transition: color 0.3s;
  cursor: pointer;

  :hover {
    color: ${({ theme }) => theme.colors.BLUE.B400};

    ${StyledCheckbox} {
      border-color: ${({ theme }) => theme.colors.BLUE.B400};
    }
  }
`;

const ICON_SIZE = 14;

const CheckboxComponent = ({
  selected = false,
  description,
  handleChange,
}: CheckboxProps) => {
  return (
    <StyledCheckboxWrapper onClick={() => handleChange()}>
      <StyledCheckbox selected={selected}>
        {selected && <CheckIcon width={ICON_SIZE} height={ICON_SIZE} />}
      </StyledCheckbox>
      <StyledCheckboxCaption>{description}</StyledCheckboxCaption>
    </StyledCheckboxWrapper>
  );
};

export default CheckboxComponent;
